import { render, staticRenderFns } from "./menuSetLevel3.vue?vue&type=template&id=4be25f81&scoped=true"
import script from "./menuSetLevel3.vue?vue&type=script&lang=js"
export * from "./menuSetLevel3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be25f81",
  null
  
)

export default component.exports